export default "__VITE_ASSET__CY7VIETS__"